import { render, staticRenderFns } from "./detail-table.vue?vue&type=template&id=1e7f7ca5&scoped=true"
import script from "./detail-table.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-table.vue?vue&type=style&index=0&id=1e7f7ca5&prod&lang=css"
import style1 from "./detail-table.vue?vue&type=style&index=1&id=1e7f7ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7f7ca5",
  null
  
)

export default component.exports